/* eslint-disable import/prefer-default-export */
export const FLOW_STEPS = {
  WELCOME: 'welcome',
  EMAIL_SIGNUP: 'email-signup',
  EMAIL_LOGIN: 'email-login',
  PASSWORD_RESET_LINK: 'password-reset-link',
  VERIFY_PHONE_NUMBER: 'verify-phone-number',
  PHONE_SIGNUP: 'phone-signup',
  VERIFY_EMAIL: 'verify-email',
  SINGPASS: 'singpass',
};
